module.exports = __webpack_public_path__ + "static/media/激光切割爬行机器人.6050895f.png";